// extracted by mini-css-extract-plugin
export default {"productGrid":"Qaa-z","centerLink":"Raa-z","productSection":"Saa-z","item":"Taa-z","ctaButton":"Uaa-z"};